module.exports = __webpack_public_path__ + "img/1493877609.0c930466.jpg";